export default "__VITE_ASSET__395bda69__"